module.exports = __webpack_public_path__ + "static/assets/dabdbab5966f0f9d5d3f40e79f00c0a3.png";